import { z } from 'zod';

export const registrationStepNameSchema = z.object({
    public_name: z
        .string()
        .trim()
        .min(1, 'Имя обязательно')
        .max(100, 'Имя слишком длинное')
        .regex(/^[^\p{Emoji}\p{Emoji_Component}]+$/u, "Эмодзи не разрешены")
        .regex(/^[\p{L}\s]+$/u, 'Разрешены только буквы и пробелы')
        .refine((val) => val.trim().length > 0, {
            message: 'Имя не может состоять только из пробелов',
        })
});

export type RegistrationStepNameType = z.infer<typeof registrationStepNameSchema>;
